/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Add_Customer_Storage_Gateway_NoteInputs */



/**
* | output |
* | --- |
* | "Gateway includes a fixed 25 GB — no storage add-on." |
*
* @param {Partner_Add_Customer_Storage_Gateway_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_add_customer_storage_gateway_note = /** @type {((inputs?: Partner_Add_Customer_Storage_Gateway_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Add_Customer_Storage_Gateway_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gateway enthält feste 25 GB – kein Speicher-Add-on.")
	return /** @type {LocalizedString} */ ("Gateway includes a fixed 25 GB — no storage add-on.")
});